<style lang="scss">
    @import "../../../../sass/layout/tables";
    .org-width { 
        /* max-width: 180px; */
        word-wrap: break-word;
    }
</style>

<style lang="scss" scoped>
    // override styles from tables layout
    .table-template .page-item:first-child .page-link,
    .table-template .page-item:last-child .page-link {
        font-size: 2.0em;
    }
</style>

<template>
    <div class="users-list table-template">
        <div class="row rounded-top consultants">
            <div class="arrow-consultants">
                <img :src="$basePath + '/images/orange_arrow_blue_border.png'">
                <span class="table-title">Consultants</span>
            </div>
        </div>
        <div>
            <div class="row justify-content-center">
                <data-table
                    table-id="connected-programs-table"
                    :items="users"
                    :fields="fields"
                    :empty-text="emptyText"
                    :show-search-input="true"
                    :show-items-per-page-select="true"
                >
                    <template #name="{ item }">
                        <a v-bind:href="$basePath+'/consultants/'+item.id">{{ item.name }}</a>
                    </template>
                    <template #organization_type="{ item }">
                        {{ item.organization_type ? item.organization_type.name : '--' }}
                    </template>
                    <template #connections="{ item }">
                        {{ (item.program_count) ? item.program_count : 0 }} Programs Connected <br />
                        {{ (item.child_count) ? item.child_count : 0 }} Children Served
                    </template>
                    <template #counties_served="{ item }">
                        <div v-for="(county_served, index) in item.counties_served">
                            <span v-show="item.show_all_counties || index < 3">{{ county_served.name }}</span><span v-if="index+1 < item.counties_served.length" v-show="item.show_all_counties || index < 3">, </span>
                        </div>
                        <span v-if="item.counties_served.length > 3" v-on:click="toggleShowCounties(item)">
                            <span v-if="item.show_all_counties" class="btn-link small">show less</span>
                            <div v-else>
                                <span>&hellip;</span><br />
                                <span class="btn-link">show more</span>
                            </div>
                        </span>
                    </template>
                    <template #latest_activity_log="{ item }">
                        <span>{{ formatDate(item.latest_activity_log?.date) }}</span>
                    </template>
                </data-table>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    import DataTable from '../../DataTable.vue';

    export default {
        components: {
            moment,
            DataTable
        },
        data: function () {
            return {
                users: [],
                fields: [
                {
                    key: 'name',
                    label: 'Consultant Name',
                    sortable: true,
                    compareFn: 'compareByKey',
                },
                {
                    key: 'organization_type',
                    label: 'Organization Type',
                    sortable: true,
                    compareFn: 'compareByKey',
                    compareKey: 'organization_type.name',
                },
                {
                    key: 'connections',
                    label: 'Connections',
                    sortable: false
                },
                {
                    key: 'counties_served',
                    label: 'County',
                    sortable: false,
                },
                {
                    key: 'latest_activity_log',
                    label: 'TA Activity',
                    sortable: true,
                    compareFn: 'compareDateByKey',
                }],
            }
        },
        methods: {
            fetchUsers: function () {
                axios.get('/api/consultants/list?with=connections,countiesServed,organizationType,program,program.consultants,program.county')
                .then(function(response){ 
                    this.users = response.data.data
                }.bind(this))
                .catch(function(error){
                 })
            },
            toggleShowCounties: function( data ) {
                if (data.hasOwnProperty('show_all_counties')) {
                    data.show_all_counties = !data.show_all_counties;
                } else {
                    data.show_all_counties = true;
                }
            },
            formatDate: function (value) {
                if (value) {
                    return moment(String(value)).format('MM/DD/YYYY')
                }
            }
        },
        computed: {
            emptyText: function() {
                return "There are no consultants to display.";
            },
        },
        mounted: function () {
            this.fetchUsers();
        }
    }
</script>